import React from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { DimensionEnums } from "models/enums";
import { ForcedDimensions } from "models/propTypes/dimensionPropTypes";
import { ArrayHelper } from "utils/helpers";

function useDimensionMaps(type: DimensionEnums.DimensionCategory) {
  const dimensions = useSelector((store: AppState) => {
    switch (type) {
      case DimensionEnums.DimensionCategory.IncomingInvoice:
        return store.common.dimensions.incomingInvoiceDimensions ?? [];
      case DimensionEnums.DimensionCategory.Receipt:
        return store.common.dimensions.receiptDimensions ?? [];
      case DimensionEnums.DimensionCategory.Invoice:
        return store.common.dimensions.invoiceDimensions ?? [];
      case DimensionEnums.DimensionCategory.CashReconciliation:
        return store.common.dimensions.cashReconciliationDimensions ?? [];
      case DimensionEnums.DimensionCategory.All:
        return store.common.dimensions.allDimensions ?? [];
      case DimensionEnums.DimensionCategory.MissingDocumentOther:
        return ArrayHelper.uniqueBy(
          (store.common.dimensions.incomingInvoiceDimensions ?? []).concat(
            store.common.dimensions.receiptDimensions ?? []
          ),
          (x) => x.key.id
        );
    }
  });

  const [forcedDimensionMap, setForcedDimensionMap] = React.useState<ForcedDimensions[]>([]);

  React.useEffect(() => {
    const forcedDimensionMap = dimensions
      .filter((x) => x.key.isForced)
      .map((x) => ({
        type: x.key,
        dimensionIds: x.value.map((x) => x.id ?? "") ?? [],
      }));
    setForcedDimensionMap(forcedDimensionMap);
  }, [dimensions]);

  const recommendedDimensions = dimensions.map((d) => d.key.recommendedDimensionId).filter((d) => d) as string[];

  return { dimensions, forcedDimensionMap, recommendedDimensions };
}

export default useDimensionMaps;
